import { useState } from "react";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";

import { APP_ROUTES } from "helpers/routeHelpers";
import { createFeedbackForm } from "api/api.service";
import typography from "../typography";
import FeedbackFormBuilder from "../FeedbackFormBuilder/FeedbackFormBuilder";

export default function AddFeedbackForm() {
    const history = useHistory();
    const [isSaving, setIsSaving] = useState(false);

    const backButtonHandler = () => {
        history.push(APP_ROUTES.FEEDBACK_FORMS);
    };

    const handleSubmit = async (values) => {
        try {
            setIsSaving(true);
            await createFeedbackForm({
                questions: values.questions.map((q) => ({
                    content: q.content.trim(),
                    type: q.type,
                    requiredField: q.requiredField,
                    ...(q.type === "OPTIONS" && {
                        answerOptions: q.answerOptions.map((o) => ({ content: o.content.trim() })),
                    }),
                })),
            });
            toast.success("Feedback form created and set as active");
            history.push(APP_ROUTES.FEEDBACK_FORMS);
        } catch (error) {
            // handleFetchError (utils/errorHandler.js) already toasts the server's message
            // for any 4xx response — no need to toast again here.
            console.error("Error creating feedback form:", error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <FeedbackFormBuilder
            heading={typography.ADD_FEEDBACK_FORM}
            backButtonHandler={backButtonHandler}
            onSubmit={handleSubmit}
            isSaving={isSaving}
        />
    );
}
